import { AnyAction } from 'redux';
import {
  App,
  determineLaufzeit,
  Vertragsoptionen,
  VorvertragVorschaeden,
} from '@ps20-frontend/frontend-models';
import { GlobalActions, TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { Selbstbeteiligung, VorschadenArt } from '@ps20/bff-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { IAppState } from '../appState';
import { GegeActions, SelbstbeteiligungChangedVorvertragAction } from '../gegeActions';

export const gegeVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.GEGE, state);

  switch (action.type) {
    case GegeActions.SELBSTBETEILIGUNG_CHANGED:
      return getNewSelbstbeteiligung(
        sectionState,
        action as SelbstbeteiligungChangedVorvertragAction,
      );
    case TARIF_CHECKED:
      return checkTarif(sectionState, state, action);
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.GEGE, state.angebotsId);
    }
    case GegeActions.FAHRRAD_VORSCHAEDEN_VORHANDEN_CHANGED:
      return {
        ...sectionState,
        selbstbeteiligung: getSelbstbeteiligungFromVorschaeden(
          action.payload.provided ? state.fahrradVorschaeden.count : null,
        ),
      };
    case GegeActions.FAHRRAD_VORSCHAEDEN_COUNT_CHANGED:
      return {
        ...sectionState,
        selbstbeteiligung: getSelbstbeteiligungFromVorschaeden(action.payload.value),
      };
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      const actionPayload: Array<VorvertragVorschaeden> = action.payload;
      const vorvertragVorschaeden = actionPayload.find(
        vv =>
          vv.appId === App.GEGE &&
          vv.angebotsId === state.angebotsId &&
          vv.vorschaedenArt === VorschadenArt.RAD,
      );
      if (vorvertragVorschaeden == null) {
        return sectionState;
      }
      const anzahl = vorvertragVorschaeden.anzahlVorschaeden > 0 ? vorvertragVorschaeden.anzahlVorschaeden : null;
      return {
        ...sectionState,
        selbstbeteiligung: getSelbstbeteiligungFromVorschaeden(anzahl),
      };
    }
    default:
      return sectionState;
  }
};

function getNewSelbstbeteiligung(
  sectionState: IAppState['vertragsoptionen'],
  action: SelbstbeteiligungChangedVorvertragAction,
): IAppState['vertragsoptionen'] {
  const selbstbeteiligung: Selbstbeteiligung = action.payload;
  return { ...sectionState, selbstbeteiligung };
}

function checkTarif(
  sectionState: IAppState['vertragsoptionen'],
  state: IAppState,
  action: AnyAction,
): IAppState['vertragsoptionen'] {
  const newState: Vertragsoptionen = cloneDeep(sectionState);
  determineLaufzeit(action, newState, state.produkt, sectionState);
  return newState;
}

const getSelbstbeteiligungFromVorschaeden = (count: number | null): Selbstbeteiligung => {
  switch (count) {
    case 1:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_10_PROZENT;
    case 2:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT;
    case 3:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_30_PROZENT;
    default:
      return Selbstbeteiligung.SELBSTBETEILIGUNG_0000;
  }
};
